<gp-list>
  <ng-content></ng-content>
</gp-list>
